import { Checkbox, FormControlLabel, Grid } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { BorderedFormGrid } from "../../../Forms/BorderedFormGrid";
import { useResolveGeoCoordinates } from "../../../GoogleMaps/useResolveGeoCoordinates";
import { CountrySelect } from "../../../Locations/CountrySelect";
import Supplier from "../../Supplier";
import { SupplierFormProps } from "../SupplierFormProps";
import { updateCountryCode } from "../updateCountryCode";
import { TextFieldInput } from "../../../Forms/TextFieldInput";
import { GeoCoordinatesAddressTextField } from "../GeoCoordinatesAddressTextField";
import { isNotEmpty } from "../../../Utils/strings";

export const SupplierOptionalAddressForm = ({ disabledFields }: SupplierFormProps) => {
  const { control, setValue, getValues } = useFormContext<Supplier>();

  const { resolveGeoCoordinatesIfAddressIsComplete } = useResolveGeoCoordinates<Supplier>(
    "AltStreet",
    "AltZipcode",
    "AltCity",
    "AltLatitude",
    "AltLongitude"
  );

  return (
    <BorderedFormGrid>
      <Grid item xs={4}>
        <GeoCoordinatesAddressTextField
          name="AltStreet"
          control={control}
          label="Street"
          disabledFields={disabledFields}
          triggerGeoCoordinatesCalculation={(fallbackGeoCoordinates) => {
            setValue("AltLatitude", fallbackGeoCoordinates.latitude);
            setValue("AltLongitude", fallbackGeoCoordinates.longitude);
            if (isNotEmpty(getValues("AltStreet"))) resolveGeoCoordinatesIfAddressIsComplete();
          }}
        />
      </Grid>
      <Grid item xs={4}>
        <TextFieldInput
          name="AltRegion"
          control={control}
          label="Region"
          disabledFields={disabledFields}
        />
      </Grid>
      <Grid item xs={4}>
        <TextFieldInput
          name="AltCountryCode"
          control={control}
          label="CMMS Country Code"
          disabledFields={disabledFields}
        />
      </Grid>

      {/* SECOND ROW */}
      <Grid item xs={4}>
        <GeoCoordinatesAddressTextField
          name="AltZipcode"
          control={control}
          label="Postcode"
          disabledFields={disabledFields}
          triggerGeoCoordinatesCalculation={(fallbackGeoCoordinates) => {
            setValue("AltLatitude", fallbackGeoCoordinates.latitude);
            setValue("AltLongitude", fallbackGeoCoordinates.longitude);
            if (isNotEmpty(getValues("AltZipcode"))) resolveGeoCoordinatesIfAddressIsComplete();
          }}
        />
      </Grid>
      <Grid item xs={4}>
        <CountrySelect
          control={control}
          name="AltCountryID"
          onCountryChanged={(countryId, countries) =>
            setValue("AltCountryCode", updateCountryCode(countryId, countries))
          }
        />
      </Grid>
      <Grid item xs={4}>
        <TextFieldInput
          name="AltAreaCode"
          control={control}
          label="CMMS Area Code"
          disabledFields={disabledFields}
        />
      </Grid>

      {/* THIRD ROW */}
      <Grid item xs={4}>
        <TextFieldInput
          name="AltZipArea"
          control={control}
          label="Postcode Area"
          disabledFields={disabledFields}
        />
      </Grid>
      <Grid item xs={4} />
      <Grid item xs={4} />

      {/* FOURTH ROW */}
      <Grid item xs={4}>
        <GeoCoordinatesAddressTextField
          name="AltCity"
          control={control}
          label="City"
          disabledFields={disabledFields}
          triggerGeoCoordinatesCalculation={(fallbackGeoCoordinates) => {
            setValue("AltLatitude", fallbackGeoCoordinates.latitude);
            setValue("AltLongitude", fallbackGeoCoordinates.longitude);
            if (isNotEmpty(getValues("AltCity"))) resolveGeoCoordinatesIfAddressIsComplete();
          }}
        />
      </Grid>
      {/* PLACEHOLDER TIME ZONE */}
      <Grid item xs={4} />
      {/* PLACEHOLDER */}
      <Grid item xs={4} />

      {/* FIFTH ROW */}
      <Grid item xs={4}>
        <Controller
          name="AltLocationForContainerReturns"
          control={control}
          render={({ field }) => (
            <FormControlLabel
              control={
                <Checkbox {...field} checked={field.value === true} onClick={field.onChange} />
              }
              label="For Container Returns"
            />
          )}
        />
      </Grid>
    </BorderedFormGrid>
  );
};
